<div class="modal-overlay">
    <div class="modal-container">
        <div class="modal-header">
            <div class="title-wrapper">
                <h2>Sign PDF - Corp Authority Form</h2>
            </div>
            <button class="close-btn" (click)="onCancel()">×</button>
        </div>

        <div class="modal-body">
            <div class="step-content">
                <div class="pdf-signing-container">
                    <!-- Left Side: PDF Viewer -->
                    <div class="pdf-viewer-section">
                        <div class="pdf-container" #pdfContainer (mousemove)="onPdfMouseMove($event)" (mouseup)="onPdfMouseUp()">
                            <div *ngIf="isPdfLoading" class="pdf-loading-overlay">
                                <div class="pdf-loading-spinner"></div>
                            </div>
            
                           @if(showPdf){ <pdf-viewer [src]="{url: pdfSource,
                                enableXfa: true}" [render-text]="true" [original-size]="false" [fit-to-page]="false"
                                [show-all]="true" [autoresize]="true" (after-load-complete)="onPdfLoaded($event)"
                                style="display:block; width:100%; height:100%;">
                            </pdf-viewer>}
            
                            <!-- Placed Signature Overlay -->
                            <div *ngIf="placedSignature" class="signature-overlay" [class.fixed]="placedSignature.isFixed"
                                [style.left.px]="placedSignature.x" [style.top.px]="placedSignature.y"
                                [style.width.px]="placedSignature.width" [style.height.px]="placedSignature.height"
                                (mousedown)="onSignatureMouseDown($event)" #signatureOverlay>
            
            
                                <!-- Typed Signature -->
                                <div *ngIf="placedSignature.type === 'typed'" class="typed-signature">
                                    {{ placedSignature.data }}
                                </div>
            
                                <!-- Drawn Signature -->
                                <img *ngIf="placedSignature.type === 'drawn'" [src]="placedSignature.data" alt="Signature"
                                    class="signature-image">
            
                                <!-- Uploaded Signature -->
                                <img *ngIf="placedSignature.type === 'uploaded'" [src]="placedSignature.data" alt="Signature"
                                    class="signature-image">
            
                                <img *ngIf="placedSignature.type !== 'typed'" [src]="placedSignature.data"
                                    style="width:100%; height:100%;" alt="Signature">
            
                                <button *ngIf="!placedSignature.isFixed" class="fix-signature-btn" (click)="fixSignature()"
                                    title="Fix signature position">✓</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pdf-signing-container">
            
                    <!-- Right Side: Signature Options -->
                    <div class="signature-options-section">
                        <h3 class="section-title">Sign PDF @if(!docData?.isSigned) {<span class="asterisk">*</span>}</h3>
                        @if(!docData?.isSigned) {
                            <app-text-input aria-label="sign-pdf" class="search-text"
                            [control]="inputForm.controls['signText']" [for]="'sign-text'"
                            [hideLabel]="true" id="sign-input" [placeholder]="'Type your name here'"
                            [maxLength]="90" [errorMessages]="customErrorMessages"></app-text-input>
                        }
                        <!-- Type Signature -->
                        <div class="signature-method">

                            @if(!docData?.isSigned || !isSignatureFixed) {
                                @if(!isSignatureFixed){
                                    <app-button [ngClass]="(isSignerNameAutoResolved ? false : (!inputForm.get('signText')?.value?.trim() || inputForm.get('signText')?.invalid)) ? 'btn-mgr search-btn-claim disableButton' : 'btn-mgr search-btn-claim'"
                                    label="Use Typed Signature" (click)="(isSignerNameAutoResolved || (inputForm.get('signText')?.value?.trim() && !inputForm.get('signText')?.invalid)) ? useTypedSignature() : null"
                                    [isFilled]="false" [buttonType]="'primary'">
                                    </app-button>
                                }
                                <app-button [ngClass]="(!isSignatureFixed) ? 'btn-mgr search-btn-claim disableButton' : 'btn-mgr search-btn-claim'"
                                label="Upload Signed PDF" (click)="(!isSignatureFixed) ? null : uploadSignedPdf()" [isFilled]="false" [buttonType]="'primary'">
                                </app-button>
                            } 
                            @if (docData?.isSigned) {
                                <app-button class="btn-mgr search-btn-claim" label="Download" [isFilled]="false"
                                [buttonType]="'primary'"
                                (click)="onViewDocument(documentTitle != 'Uniform Requirements' ? docData : 'ddmo_uniform_requirements.pdf')"
                                id="viewDocument"></app-button>
                                <app-button class="btn-mgr search-btn-claim" label="Delete" [isFilled]="false" [buttonType]="'primary'"
                                (click)="onDeleteDocument(docData)" id="deleteDocument"></app-button>
                               
                            }
                        </div>
            
                    </div>
                </div>
            </div>
           
        </div>

        <div class="modal-footer">
            <button class="btn-cancel" (click)="onCancel()">Cancel</button>
        </div>
    </div>
</div>